import { render } from "./LoginBosa.vue?vue&type=template&id=320ba7f2&scoped=true"
import script from "./LoginBosa.vue?vue&type=script&lang=js"
export * from "./LoginBosa.vue?vue&type=script&lang=js"

import "./LoginBosa.vue?vue&type=style&index=0&id=320ba7f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320ba7f2"]])

export default __exports__